// material-ui
import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// project imports
import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';
import getApiUrl from 'utils/getApiUrl';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [appName, setAppName] = useState('');
  const [namaGudang, setNamaGudang] = useState('');

  useEffect(() => {
    const authUser = localStorage.getItem('auth_user');
    const user = authUser ? JSON.parse(authUser) : null;
    const id_perusahaan = user ? user.id_perusahaan : '';
    const isLevel0 = Boolean(user && user.level !== null && user.level !== undefined && user.level !== '' && String(user.level) === '0');
    const id_gudang = isLevel0 ? 0 : (user ? user.id_gudang : '');
    const token = (user && user.token) || localStorage.getItem('token') || '';
    const apiUrl = getApiUrl();

    if (id_perusahaan) {
      fetch(`${apiUrl}/aplikasi?id_perusahaan=${id_perusahaan}`)
        .then((res) => res.json())
        .then((data) => {
          if (data && data.nama_aplikasi) {
            setAppName(data.nama_aplikasi);
          }
        })
        .catch((err) => console.error(err));
    }

    if (isLevel0) {
      setNamaGudang('Semua Gudang');
    } else if (id_gudang) {
      fetch(`${apiUrl}/gudang`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            const matched = data.find((g) => String(g.id) === String(id_gudang));
            if (matched) {
              setNamaGudang(matched.nm_gudang);
              if (user && user.nm_gudang !== matched.nm_gudang) {
                user.nm_gudang = matched.nm_gudang;
                localStorage.setItem('auth_user', JSON.stringify(user));
              }
            }
          }
        })
        .catch((err) => console.error(err));
    } else if (user && user.nm_gudang) {
      setNamaGudang(user.nm_gudang);
    }
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2, justifyContent: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.2 }}>
          Selamat datang,
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main', lineHeight: 1.2 }}>
          {appName || 'Aplikasi Inventory Multi Gudang'}{namaGudang ? ` - ${namaGudang}` : ''}
        </Typography>
      </Box>

      <Box sx={{ width: '100%', ml: 1, flexGrow: 1 }} />

      {!downLG && <Search />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
